<template>
  <div>
    <section>
      <div 
        class="title font-weight-bold black--text"
        style="opacity: 70%;">
        #Keluarga Abdi Dalem
      </div>

      <div>
        <tables :config="config()" />
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {

    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/user_family?user_id=${this.$route.params.id}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'pa-0',

          // HEIGHT
          height: true,

          // SHADOW
          shadow: false,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'name',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Kalenggahan',
              width: '200px',
              value: 'kalenggahan_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Hubungan',
              width: '200px',
              value: 'relation',
              freeze: false,
              hide: false
            },
            {
              text: 'Jenis Kelamin',
              width: '200px',
              value: 'gender',
              freeze: false,
              hide: false
            },
            {
              text: 'Tempat Lahir',
              width: '200px',
              value: 'birthplace',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Lahir',
              width: '200px',
              value: 'birthdate',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Usia',
              width: '250px',
              value: 'age',
              freeze: false,
              hide: false
            },
            {
              text: 'Pekerjaan',
              width: '200px',
              value: 'job',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'user_id',
              label: 'USER ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: this.$route.params.id,
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'name',
              label: 'Nama Lengkap',
              type: 'text',
              placeholder: 'Contoh. John Doe',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'kalenggahan_name',
              label: 'Nama Kalenggahan',
              type: 'text',
              placeholder: 'Contoh. RADEN MAS NGABEI',
              value: '',
              width: '70%',
              required: false

              // field: 'kalenggahan_name',
              // label: 'Nama Kalenggahan',
              // type: 'tree',
              // placeholder: 'Contoh. RADEN MAS NGABEI',
              // value: '',
              // option: [
              //   {
              //     text: 'SENTANA',
              //     value: 'SENTANA',
              //     sub: [
              //       {
              //         text: 'LAKI-LAKI',
              //         value: 'LAKI-LAKI',
              //         child: [
              //           {
              //             text: 'RADEN MAS NGABEI',
              //             value: 'RADEN MAS NGABEI'
              //           },
              //           {
              //             text: 'RADEN MAS WEDANA',
              //             value: 'RADEN MAS WEDANA'
              //           },
              //           {
              //             text: 'RADEN MAS RIYA',
              //             value: 'RADEN MAS RIYA'
              //           },
              //           {
              //             text: 'KANJENG RADEN MAS TUMENGGUNG',
              //             value: 'KANJENG RADEN MAS TUMENGGUNG'
              //           },
              //           {
              //             text: 'KANJENG PANGERAN HARYO',
              //             value: 'KANJENG PANGERAN HARYO'
              //           },
              //           {
              //             text: 'GUSTI PANGERAN HARYO',
              //             value: 'GUSTI PANGERAN HARYO'
              //           },
              //           {
              //             text: 'BENDARA PANGERAN HARYO',
              //             value: 'BENDARA PANGERAN HARYO'
              //           }
              //         ]
              //       },
              //       {
              //         text: 'PEREMPUAN',
              //         value: 'PEREMPUAN',
              //         child: [
              //           {
              //             text: 'RADEN AJENG WEDANA',
              //             value: 'RADEN AJENG WEDANA'
              //           },
              //           {
              //             text: 'RADEN NGANTEN WEDANA',
              //             value: 'RADEN NGANTEN WEDANA'
              //           },
              //           {
              //             text: 'RADEN AYU RIYA',
              //             value: 'RADEN AYU RIYA'
              //           },
              //           {
              //             text: 'KANJENG RADEN AYU TUMENGGUNG',
              //             value: 'KANJENG RADEN AYU TUMENGGUNG'
              //           },
              //           {
              //             text: 'KANJENG RADEN NGANTEN TUMENGGUNG',
              //             value: 'KANJENG RADEN NGANTEN TUMENGGUNG'
              //           },
              //           {
              //             text: 'BENDARA RADEN AYU',
              //             value: 'BENDARA RADEN AYU'
              //           }
              //         ]
              //       }
              //     ]
              //   },
              //   {
              //     text: 'ABDI DALEM',
              //     value: 'ABDI DALEM',
              //     sub: [
              //       {
              //         text: 'LAKI-LAKI',
              //         value: 'LAKI-LAKI',
              //         child: [
              //           {
              //             text: 'JAJAR MAS',
              //             value: 'JAJAR MAS'
              //           },
              //           {
              //             text: 'MAS BEKEL',
              //             value: 'MAS BEKEL'
              //           },
              //           {
              //             text: 'MAS LURAH',
              //             value: 'MAS LURAH'
              //           },
              //           {
              //             text: 'MAS NGABEI',
              //             value: 'MAS NGABEI'
              //           },
              //           {
              //             text: 'RADEN WEDANA',
              //             value: 'RADEN WEDANA'
              //           },
              //           {
              //             text: 'MAS WEDANA',
              //             value: 'MAS WEDANA'
              //           },
              //           {
              //             text: 'RADEN RIYA',
              //             value: 'RADEN RIYA'
              //           },
              //           {
              //             text: 'MAS RIYA',
              //             value: 'MAS RIYA'
              //           },
              //           {
              //             text: 'KANJENG RADEN TUMENGGUNG',
              //             value: 'KANJENG RADEN TUMENGGUNG'
              //           },
              //           {
              //             text: 'KANJENG MAS TUMENGGUNG',
              //             value: 'KANJENG MAS TUMENGGUNG'
              //           }
              //         ]
              //       },
              //       {
              //         text: 'PEREMPUAN',
              //         value: 'PEREMPUAN',
              //         child: [
              //           {
              //             text: 'JAJAR NYI',
              //             value: 'JAJAR NYI'
              //           },
              //           {
              //             text: 'NYI MAS BEKEL',
              //             value: 'NYI MAS BEKEL'
              //           },
              //           {
              //             text: 'NYI MAS LURAH',
              //             value: 'NYI MAS LURAH'
              //           },
              //           {
              //             text: 'NYI MAS NGABEI',
              //             value: 'NYI MAS NGABEI'
              //           },
              //           {
              //             text: 'NYI MAS WEDANA',
              //             value: 'NYI MAS WEDANA'
              //           },
              //           {
              //             text: 'NYI MAS RIYA',
              //             value: 'NYI MAS RIYA'
              //           },
              //           {
              //             text: 'NYI MAS TUMENGGUNG',
              //             value: 'NYI MAS TUMENGGUNG'
              //           }
              //         ]
              //       }
              //     ]
              //   }
              // ],
              // width: '70%',
              // required: false
            },
            {
              field: 'relation',
              label: 'Hubungan',
              type: 'select',
              placeholder: 'Contoh. Suami',
              value: '',
              option: [
                {
                  text: 'ISTRI',
                  value: 'ISTRI'
                },
                {
                  text: 'SUAMI',
                  value: 'SUAMI'
                },
                {
                  text: 'BAPAK',
                  value: 'BAPAK'
                },
                {
                  text: 'IBU',
                  value: 'IBU'
                },
                {
                  text: 'ANAK',
                  value: 'ANAK'
                }
              ],
              width: '40%',
              required: false
            },
            {
              field: 'gender',
              label: 'Jenis Kelamin',
              type: 'select',
              placeholder: 'Contoh. LAKI-LAKI',
              value: '',
              option: [
                {
                  text: 'LAKI-LAKI',
                  value: 'LAKI-LAKI'
                },
                {
                  text: 'PEREMPUAN',
                  value: 'PEREMPUAN'
                }
              ],
              width: '50%',
              required: false
            },
            {
              field: 'birthplace',
              label: 'Tempat Lahir',
              type: 'text',
              placeholder: 'Contoh. Yogyakarta',
              value: '',
              width: '70%',
              required: false
            },
            {
              field: 'birthdate',
              label: 'Tanggal Lahir',
              type: 'date',
              placeholder: 'Contoh. 1992-08-20',
              value: '',
              width: '45%',
              required: false
            },
            {
              field: 'job',
              label: 'Pekerjaan',
              type: 'text',
              placeholder: 'Contoh. Programer',
              value: '',
              width: '70%',
              required: false
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/user_family/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/user_family/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/user_family/delete'
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: '',
              form: {}
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>